const NSFW_STEAM_TAGS = new Set([
  "sexual content",
  "nudity",
  "hentai",
  "nsfw",
]);

export function hasNsfwSteamTag(tags) {
  return Array.isArray(tags) && tags.slice(0, 3).some(tag =>
    NSFW_STEAM_TAGS.has(String(tag ?? "").trim().toLowerCase())
  );
}

export function shouldHideSteamVideo(tags, showNsfwVideos = false) {
  return hasNsfwSteamTag(tags) && !showNsfwVideos;
}
